export default __webpack_public_path__ + "static/media/jack.49d83cbb.png";